module.exports = __webpack_public_path__ + "img/cos_demo.a665dfb7.png";